export default __webpack_public_path__ + "static/media/24365.c4f373bd.gif";